import exportFromJSON from "export-from-json"
import Toast from "./toast"

const ExportarExcel = {
    generar: (data, fileName) => {
        try {
            if (data && fileName) {
                const exportType = "xls"
                exportFromJSON({ data, fileName, exportType })
            } else {
                Toast.error(`Ocurrio un problema, no se pudo exportar la información solicitada`)
                console.error(`Ocurrio un error con las variables "data" o "fileName"`)
            }
        } catch (error) {
            Toast.error(`Ocurrio un problema, no se pudo exportar la información solicitada`)
            console.error(`error`, error)
        }
    }
}

export default ExportarExcel